import { CopyButton } from "@expert/common-ui";
import { useCustomerAvatar } from "@expert/contentful";
import { useExpertUniversityStore } from "@expert/expert-university";
import { Flex, Group, Image, Stack, Tabs, Text } from "@mantine/core";
import { PhoneNumber, ProperName } from "@/common-ui";
import { HomeProductFlow } from "@/sales-tools/home-product/components/HomeProductFlow";
import { SaleView } from "@/sales-tools/home-product/components/StepSpecific/SaleView";
import { EligibilityStatus } from "@/sales-tools/home-product/types";
import { useSessionId, useTypedMostRecentTask } from "@/sdk";
import { removeCountryCode } from "@/shared-utils";
import classes from "./MockCustomerPanel.module.css";
import { ShieldIcon } from "./ShieldIcon";

function MockCustomerProfile() {
    const { voiceTask } = useTypedMostRecentTask();

    const profileId = useExpertUniversityStore((state) => state.profileId);

    const sessionId = useSessionId();

    const customerAvatarUrl = useCustomerAvatar(sessionId);
    if (!voiceTask) {
        return null;
    }
    return (
        <Flex className={classes.topSection}>
            <Group justify="space-between" gap="0" align="top" wrap="nowrap">
                <Group gap="0" wrap="nowrap">
                    <Image className={classes.profilePicture} data-testid="customer-avatar" src={customerAvatarUrl} />

                    <Stack gap="0">
                        <ProperName
                            data-testid="customer-name"
                            size="sm"
                            truncate
                            name={profileId?.replaceAll("_", " ")}
                            className={`${classes.name} fs-mask`}
                        />

                        <Group gap="0">
                            <Text
                                w="max-content"
                                className={`${classes.customerIdentifier} fs-mask data-testid="customer-mdn"`}
                                size="sm"
                            >
                                <PhoneNumber mdn={voiceTask.mdn} />
                            </Text>
                            <CopyButton value={removeCountryCode(voiceTask.mdn)} />
                        </Group>
                        <Flex gap="4px" w="max-content">
                            <Text c="dark.2" size="xxs" pr="4px">
                                {`Protected for 1+ years`}
                            </Text>
                            <ShieldIcon />
                        </Flex>
                    </Stack>
                </Group>
            </Group>
        </Flex>
    );
}

function MockSalesFlow() {
    return (
        <Tabs
            classNames={{ root: classes.root }}
            radius={0}
            data-testid="multi-product-tab-container"
            defaultValue="homePlan"
        >
            <Tabs.List grow>
                <Tabs.Tab className={classes.tab} value="homePlan">
                    <Flex className={classes.tabHeader} justify="center">
                        <Text size="xs">Primary</Text>
                    </Flex>
                </Tabs.Tab>

                <Tabs.Tab className={classes.tab} value="otherPlans">
                    <Text size="xs">Other plans</Text>
                </Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel className={classes.tabPanel} value="homePlan">
                <HomeProductFlow />
            </Tabs.Panel>

            <Tabs.Panel className={classes.tabPanel} value="otherPlans">
                <SaleView planType="Other" status={EligibilityStatus.Ineligible} />
            </Tabs.Panel>
        </Tabs>
    );
}

export function MockCustomerPanel() {
    return (
        <Flex className={classes.customerPanel} data-testid="customer-panel">
            <Flex className={classes.responsivePanel}>
                <MockCustomerProfile />
                <MockSalesFlow />
            </Flex>
        </Flex>
    );
}
